import React, {useEffect, useState} from 'react'
import {Button, Form, Icon, Modal} from "semantic-ui-react";
import to from "await-to-js";
import axios from "axios";
import {createHash} from "crypto";
import styled from "styled-components";

const MessageInfo = styled.div`
	white-space: pre-wrap;
`;

const TermsConditionsPopup = ({locale}) => {
    const [openModal, setOpenModal] = useState(false);
    const [fieldValue, setFieldValue] = useState();


    useEffect(() => {
        axios.get('/api/common/terms').then(response => {
            setFieldValue(response.data.terms);
        }).catch(ex => console.log(ex.message));
    }, []);

    return (
        <Modal
            trigger={<a href="#" onClick={() => setOpenModal(true)}>Terms and Conditions</a>}
            open={openModal}
            header='Terms and Conditions!'
        >
            <Modal.Content>
                <MessageInfo>
                    <p>{fieldValue}</p>
                </MessageInfo>
            </Modal.Content>
            <Modal.Actions>
                <div style={{paddingBottom: 50}}>
                    <Button onClick={() => setOpenModal(false)} floated='right'>
                        <Icon name='remove'/> {locale._system.close}
                    </Button>
                </div>
            </Modal.Actions>
        </Modal>
    )
}
export default TermsConditionsPopup;